
const summaryApi = {

    async getSummary(productData, currency, quantity){
        const filteredData = Object.assign( {}, productData, {
            attribute_selections: productData.attribute_selections.filter(as => as.selection)
        })
        const summary = await fetch(window.location.origin + '/api/v1/configurator/products/' + productData.id + '/summary', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({product: filteredData, currency: currency, quantity: quantity}),
        }).then(response => response.json())
        return summary;
    },

    async getPatternSummary(data, currency, quantity, patternId){
        const summary = await fetch(window.location.origin + '/api/v1/configurator/patterns/' + patternId + '/summary', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({product: data, currency: currency, quantity: quantity, patternId: patternId}),
        })
            .then(results => {
                return results.json();
            })
        return summary;
    },

    async getElementSummary(data, currency, quantity){
        //TODO update per element need - matches normal summary for now
        const summary = await fetch(window.location.origin + '/api/v1/configurator/products/' + data.id + '/element_summary', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({product: data, currency: currency, quantity: quantity}),
        }).then(response => response.json());
        return summary
    },

    async getQuickship(productData, quantity) {
        const data = Object.assign({}, productData, { quantity: quantity});
        return await fetch( window.location.origin + '/api/v1/configurator/products/can_quickship', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({product: data })
        }).then(response => response.json()).catch(err => {
            return {quickship: null}
        });
    },

    async getElementQuickship(productData, quantity, elements) {
        const data = Object.assign({}, productData, { quantity: quantity, elements_with_selections: elements});
        return await fetch( window.location.origin + '/api/v1/configurator/products/element_can_quickship', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({product: data })
        }).then(response => response.json()).catch(err => {
            return {quickship: null}
        });
    },

    async getPatternQuickship(productData, quantity, leg_catalog_numbers) {
        const data = Object.assign({}, productData, { quantity: quantity, leg_catalog_numbers: leg_catalog_numbers});
        return await fetch( window.location.origin + '/api/v1/configurator/products/pattern_can_quickship', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({product: data })
        }).then(response => response.json()).catch(err => {
            return {quickship: null}
        });
    }
};

export default summaryApi;